// client/src/components/admin/influencer/PerformanceStatDeleteModal.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

function PerformanceStatDeleteModal({ open, onClose, userId, onSuccess }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchList = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await fetch(
          `${API_URL}/api/admin/influencer/info/${userId}/satisfaction/list`,
          {
            credentials: 'include'
          }
        );
        const data = await res.json();
        if (data.ok) {
          setItems(data.items || []);
          if (data.items.length === 0) {
            setError('삭제할 만족도 점수가 없습니다.');
          }
        } else {
          setError(data.message || '목록 조회에 실패했습니다.');
        }
      } catch (err) {
        console.error('fetchList error:', err);
        setError('목록 조회 중 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    };

    if (open && userId) {
      fetchList();
    } else {
      setItems([]);
      setSelectedItem(null);
      setError('');
    }
  }, [open, userId]);

  const handleDelete = async () => {
    if (!selectedItem) {
      setError('삭제할 프로젝트를 선택해주세요.');
      return;
    }

    if (!window.confirm(`프로젝트 ${selectedItem.projectNumber}의 만족도 점수(${selectedItem.satisfactionScore}점)를 삭제하시겠습니까?\n\n삭제 후 통계가 재계산됩니다.`)) {
      return;
    }

    setDeleting(true);
    setError('');

    try {
      const res = await fetch(
        `${API_URL}/api/admin/influencer/info/${userId}/satisfaction/${selectedItem.applicationId}`,
        {
          method: 'DELETE',
          credentials: 'include'
        }
      );

      const data = await res.json();

      if (data.ok) {
        onSuccess && onSuccess();
        onClose();
      } else {
        setError(data.message || '만족도 점수 삭제에 실패했습니다.');
      }
    } catch (err) {
      console.error('handleDelete error:', err);
      setError('만족도 점수 삭제 중 오류가 발생했습니다.');
    } finally {
      setDeleting(false);
    }
  };

  if (!open) return null;

  return (
    <div
      className="performance-stat-delete-modal"
      onClick={onClose}
    >
      <div
        className="performance-stat-delete-modal__content"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="performance-stat-delete-modal__title">만족도 점수 삭제</h3>

        {loading && (
          <div className="performance-stat-delete-modal__loading">
            불러오는 중...
          </div>
        )}

        {!loading && error && items.length === 0 && (
          <div className="performance-stat-delete-modal__info-warning">
            {error}
          </div>
        )}

        {!loading && items.length > 0 && (
          <>
            <div>
              <p className="performance-stat-delete-modal__description">
                삭제할 프로젝트를 선택하세요. 선택한 프로젝트의 만족도 점수가 삭제되고 통계가 재계산됩니다.
              </p>
            </div>

            <div className="performance-stat-delete-modal__table-container">
              <table className="performance-stat-delete-modal__table">
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', width: 50 }}>선택</th>
                    <th>프로젝트 번호</th>
                    <th>광고주명</th>
                    <th style={{ textAlign: 'center', width: 60 }}>점수</th>
                    <th style={{ width: 90 }}>승인일</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => (
                    <tr 
                      key={item.applicationId}
                      className={selectedItem?.applicationId === item.applicationId ? 'selected' : ''}
                      onClick={() => setSelectedItem(item)}
                    >
                      <td style={{ textAlign: 'center' }}>
                        <input
                          type="radio"
                          checked={selectedItem?.applicationId === item.applicationId}
                          onChange={() => setSelectedItem(item)}
                          style={{ cursor: 'pointer' }}
                        />
                      </td>
                      <td>{item.projectNumber}</td>
                      <td>{item.marketerName}</td>
                      <td style={{ textAlign: 'center', fontWeight: 600, color: '#3b82f6' }}>
                        {item.satisfactionScore}점
                      </td>
                      <td>
                        {item.resultApprovedAt ? (() => {
                          const d = new Date(item.resultApprovedAt);
                          const year = d.getFullYear();
                          const month = String(d.getMonth() + 1).padStart(2, '0');
                          const day = String(d.getDate()).padStart(2, '0');
                          return (
                            <div style={{ lineHeight: 1.3, fontSize: 12 }}>
                              <div>{year}년</div>
                              <div>{month}월{day}일</div>
                            </div>
                          );
                        })() : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {error && items.length > 0 && (
          <div className="performance-stat-delete-modal__error">
            {error}
          </div>
        )}

        <div className="performance-stat-delete-modal__actions">
          <button
            onClick={onClose}
            disabled={deleting}
            className="performance-stat-delete-modal__button"
          >
            취소
          </button>
          {items.length > 0 && (
            <button
              onClick={handleDelete}
              disabled={deleting || !selectedItem}
              className="performance-stat-delete-modal__button performance-stat-delete-modal__button--danger"
            >
              {deleting ? '삭제 중...' : '삭제'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default PerformanceStatDeleteModal;

